// Pure types and constants for the /docs section — no Node-only imports (fs,
// path). This file is safe to import from client components (e.g. the docs
// sidebar). The fs-backed loader lives in docs.ts and re-exports from here.

export interface Doc {
  slug: string
  title: string
  description: string
  content: string
  category: string
  order?: number
  publishedAt: string
  updatedAt?: string
}

export const docCategories = [
  { id: "getting-started", label: "Getting Started" },
  { id: "core-concepts", label: "Core Concepts" },
  { id: "how-to", label: "How-to" },
  { id: "reference", label: "Reference" },
  { id: "troubleshooting", label: "Troubleshooting" },
] as const

export type DocCategoryId = (typeof docCategories)[number]["id"]
